import React, { FC } from 'react';
import { Grid, TableCell } from '@material-ui/core';
import { MutationResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';

import { SharesItem } from 'api';

import DeleteShare from '../DeleteShare';
import EditShare from '../EditShare';

interface IProps {
  items: SharesItem[];
  refetchQueriesOnEdit?: (
    mutationResult: MutationResult,
  ) => Array<{ query: DocumentNode; variables?: object }>;
  onDelete: (cache: DataProxy, result: MutationResult['data']) => void;
  onUpdate: (cache: DataProxy, result: MutationResult['data']) => void;
}

const ActionsCell: FC<IProps> = props => {
  const { items, refetchQueriesOnEdit, onUpdate, onDelete } = props;

  return (
    <TableCell size="small" align="right">
      <Grid container direction="column">
        <Grid item>
          <EditShare
            existingShares={items}
            refetchQueries={refetchQueriesOnEdit}
            onDelete={onDelete}
            onUpdate={onUpdate}
          />
        </Grid>
        <Grid item>
          <DeleteShare items={items} onDelete={onDelete} />
        </Grid>
      </Grid>
    </TableCell>
  );
};

export default ActionsCell;
